import { Badge, Box, Flex, FormControl, Input } from "@chakra-ui/react";
import React from "react";
import MyAutocomplete from "../../library/components/Autocomplete";

const SuggestedComic = ({ comic, setComic, story, setStory, index }) => {
  return (
    <Flex alignItems="center" pt="4">
      <Box pr="2">
        <Badge bg="gray.600" borderRadius="sm" fontSize="0.8em">
          {index}
        </Badge>
      </Box>
      <Box flex="1">
        <MyAutocomplete
          franchise={1}
          comic={comic}
          isLeadingInput={!comic}
          index={index}
          onSelectionChange={(currentIndex, selectedComic) =>
            setComic(selectedComic)
          }
          disableAutoFocus
        />
      </Box>
      <Box px="2">
        <FormControl>
          <Input
            htmlSize={4}
            placeholder="Story"
            type="text"
            name="story"
            maxLength={1}
            value={story}
            onChange={(e) => setStory(e.target.value)}
            onBlur={() => {}}
          />
        </FormControl>
      </Box>
    </Flex>
  );
};

export default SuggestedComic;
